import React, { useRef, useEffect, useState } from 'react'
import TimesheetCustomDropodown from './TimesheetCustomDropodown'
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { ShowToast } from '../../common/Toastr';
import { getTimeFromDecimal, timeConverIntoSeconds } from '../../common/timesheetFunction';
import { updateTimerTimesheetState, addAccountEmployeeTimeEntryTimerAsync, stopAccountEmployeeTimeEntryTimerAsync, getTimer, deleteAccountEmployeeTimeEntryTimerAsync, resetTimerState } from '../../features/timesheet/timesheetSlice';
import moment from 'moment';
import { t } from "i18next";
import { getValueFromResource } from '../../common/timeLiveFunction';

interface TimesheetRowProps {
  rowId: number;
  isReadOnly?: boolean;
}

const TimesheetRow = (props: TimesheetRowProps) => {
  const { rowId, isReadOnly } = props;
  const state = useAppSelector((state) => state.timesheet);
  const { showClient, showCostCenter, showWorkType, timeEntriesList, ShowProjectForTimeOff, ShowProjectTask, startDate, endDate, timeEntryViewType,
    accountEmployeeTimeEntryPeriodId, lastEntryTimerId, accountEmployeeId, enableTimerInTimesheet, timerObject, isLocked, isSubmitted, workingDayNo, isTimerPulsing } = state;
  const pickerRef = useRef<HTMLDivElement>(null);
  const textInputRef = useRef<HTMLDivElement>(null);
  
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);

  
  const { ClientName, ProjectName, TaskName, CostCenter, WorkType, isTimeOff, AccountTimeOffType, IsTimer, AccountEmployeeTimeOffRequestId, AdditionalProjectInfo, AdditionalTaskInfo } = timeEntriesList.find(x => x.rowId === rowId);
  const { sessionAccountEmployeeId, HighlightTimeEntriesBy } = useAppSelector((state) => state.globalState);
  const dispatch = useAppDispatch();
  const currentDayNo = moment().isoWeekday().toString();
  const activeDaysArray = workingDayNo ? workingDayNo.split(',') : [];
  const isTodayWorkingDay = activeDaysArray.includes(currentDayNo);
  const [isProcessing, setIsProcessing] = useState(false); 
  
  const startTimer = (rowId: number) => {
    if (isProcessing) return;
    if (lastEntryTimerId != 0) {
      ShowToast('warning', 'Please stop the previous timer!', "warning", "toast-top-right");
    } else {
      setIsProcessing(true); 
      dispatch(resetTimerState());
      const { AccountClientId, AccountProjectId, AccountProjectTaskId, timeEntries } = timeEntriesList.find(x => x.rowId === rowId) || {};
      let accountEmployeeTimeEntryId = 0;
      timeEntries?.map((item: any) => {
        if (item.TimeEntryDate == moment(new Date()).format("YYYY-MM-DD")) {
          accountEmployeeTimeEntryId = item.AccountEmployeeTimeEntryId;
        }
      });
      let object = {
        "AccountEmployeeTimeEntryPeriodId": accountEmployeeTimeEntryPeriodId,
        "AccountClientId": AccountClientId,
        "AccountProjectId": AccountProjectId,
        "AccountProjectTaskId": AccountProjectTaskId,
        "TimerDate": moment(new Date()).format('YYYY-MM-DD'),
        "TimeEntryStartDate": startDate,
        "TimeEntryEndDate": endDate,
        "TimeEntryViewType": timeEntryViewType,
        "AccountEmployeeTimeEntryId": accountEmployeeTimeEntryId,
        "AccountEmployeeId": accountEmployeeId
      };
      dispatch(updateTimerTimesheetState([{ rowId: rowId, isPlay: true }]));
      dispatch(addAccountEmployeeTimeEntryTimerAsync(object))
        .unwrap()
        .then((result) => {
          if (Number(result.id) > 0) {
            dispatch(getTimer());
            ShowToast('Success', 'Timer Started Successfully!', "success", "toast-top-right");
          } else {
            ShowToast('error', 'The timer was not started successfully!', "error", "toast-top-right");
          }
        })
		.catch((rejectedValueOrSerializedError) => {
        })
        .finally(() => {
          setIsProcessing(false);
        });
    }
  };

  const stopTimer = (rowId: number) => {
    let tempHours = ''
    state.timeEntriesList.map((item: any) => {
      if (item.IsTimer) {
        tempHours = getTimeFromDecimal(item.timeEntries.filter((x: any) => x.TimeEntryDate == moment(new Date()).format("YYYY-MM-DD"))[0].Hours, false);
      }
    });
    dispatch(updateTimerTimesheetState([{ rowId: rowId, isPlay: false }]));
    if (timerObject[0].minutes >= 1) {
      dispatch(stopAccountEmployeeTimeEntryTimerAsync(timeConverIntoSeconds(tempHours)))
        .unwrap()
        .then((result) => {
          if (Number(result.id) > 0) {
            dispatch(resetTimerState());
            ShowToast('Success', 'TimeEntry Updated Successfully!!', "success", "toast-top-right");
          }
          else {
            ShowToast('error', 'TimeEntry is not Updated Successfully!', "error", "toast-top-right");
          }
        })
	.catch((rejectedValueOrSerializedError) => {
        })
        .finally(() => {
        });
    } else {
      dispatch(deleteAccountEmployeeTimeEntryTimerAsync()).then((result) => {
        dispatch(resetTimerState());
        ShowToast('Warning', 'To Save the entry, Total time must be 1 minute or above', "warning", "toast-top-right");
      });
    }
  }

  const handleClick = (e: any) => {
    const inputElement = pickerRef.current;
    if (inputElement) {
      if (inputElement.contains(e.target)) {
        return;
      }
    }
    setDropdownVisible(false);
  }

  const toggleDropdown = () => {
  const nextState = !dropdownVisible;
  setDropdownVisible(nextState);
  if (nextState && pickerRef.current) {
    pickerRef.current.removeAttribute('data-tooltip-id');
    pickerRef.current.removeAttribute('data-tooltip-content');
  }
}

  useEffect(() => {
    document.addEventListener("mousedown", handleClick);
    return () => {
      document.removeEventListener("mousedown", handleClick);
    }
  }, []);


const handleMouseEnter = () => {
  if (textInputRef.current && pickerRef.current && !dropdownVisible) {
    const childElements = textInputRef.current.querySelectorAll('div, span');
    let isAnyOverflowing = false;

    childElements.forEach((el: any) => {
      if (el.scrollWidth > el.clientWidth) {
        isAnyOverflowing = true;
      }
    });
    if (isAnyOverflowing) {
      pickerRef.current.setAttribute('data-tooltip-id', 'my-tooltip-styles');
      pickerRef.current.setAttribute('data-tooltip-content', tooltipText);
    } else {
      pickerRef.current.removeAttribute('data-tooltip-id');
      pickerRef.current.removeAttribute('data-tooltip-content');
    }
  }
};
 

  const getFullTooltipText = () => {
    let text = '';
    if (HighlightTimeEntriesBy === "Client" && showClient) {
      text += ClientName || '';
      if (ProjectName) text += (text ? ' • ' : '') + ProjectName;
      if (TaskName) text += (text ? ' • ' : '') + TaskName;
    } else {
      if (ShowProjectTask && TaskName) text += TaskName;
      else if (ProjectName) text += ProjectName;
      if (showClient && ClientName) text += (text ? ' • ' : '') + ClientName;
      if (ProjectName && ShowProjectTask) text += (text ? ' • ' : '') + ProjectName;
    }
    if (showCostCenter && CostCenter && !isTimeOff) text += (text ? ' • ' : '') + CostCenter;
    if (showWorkType && WorkType && !isTimeOff) text += (text ? ' • ' : '') + WorkType;
    if (isTimeOff && AccountTimeOffType) text += (text ? ' • ' : '') + AccountTimeOffType;
    return text;
  };

  const isTimerVisible = !isSubmitted &&
    enableTimerInTimesheet &&
    ProjectName != null &&
    !isTimeOff &&
    (moment(new Date()).format('yyyy-MM-DD') >= startDate && moment(new Date()).format('yyyy-MM-DD') <= endDate) &&
    (sessionAccountEmployeeId == accountEmployeeId);

  const isUnselected = ProjectName == null && (!isTimeOff || AccountTimeOffType == null);
  const tooltipText = getFullTooltipText();

  return (
    <tr className={"timesheet-row"} style={{ borderLeftStyle: 'hidden', borderRightStyle: 'hidden' }}>
      <td style={{ padding: '8px 12px', maxWidth: '380px', width: '380px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
          
          <div 
            ref={pickerRef} 
            className={"timesheet-picker"} 
            style={{ cursor: 'pointer', flex: 1, minWidth: 0, overflow: 'hidden', paddingRight: '8px' }}
            onMouseEnter={handleMouseEnter}
            data-tooltip-id="my-tooltip-styles"
            data-tooltip-content={tooltipText}
          >
      
            <div 
              ref={textInputRef}
              className={"tmg--input"} 
              onClick={isLocked ? undefined : () => toggleDropdown()}
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: '2px'
              }}
            >
             
              <div style={{ fontWeight: 'bold', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '100%' }}>
                {isUnselected ? (
                  <span style={{ color: '#172b4d', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '4px' }}>
                    {!isReadOnly && !isLocked && (
                      <span style={{ verticalAlign: 'middle' }}>
                        <i className="ki-outline ki-add-item fs-4" style={{ color: '#000' }}></i>
                      </span>
                    )}
                    {[
                      showClient && getValueFromResource('Select Client', dispatch, t),
                      showClient ? getValueFromResource('Project', dispatch, t) : getValueFromResource('Select Project', dispatch, t),
                      ShowProjectTask && getValueFromResource('Task', dispatch, t),
                      showCostCenter && getValueFromResource('Cost Center', dispatch, t),
                      showWorkType && getValueFromResource('Work Type', dispatch, t),
                    ].filter(Boolean).join(' - ')}
                  </span>
                ) : (
                  <>
                    {HighlightTimeEntriesBy === "Client" && showClient ? (
                      <>
                {showClient && ClientName && (
                  <span className="task projectTaskHeading" style={{paddingLeft: 0}}>
                    {ClientName}
                  </span>
                )}
              </>
                    ) : (
                      <>
                {ShowProjectTask ? (
                  TaskName && (
                    <span className="task projectTaskHeading" style={{paddingLeft: 0}}>
                      {/* {TaskName} */}
                      {AdditionalTaskInfo ? `${TaskName} (${AdditionalTaskInfo})` : TaskName}
                    </span>
                  )
                ) : (
                  ProjectName && (
                    <span className="project projectTaskHeading" style={{paddingLeft: 0}}>
                      {/* {ProjectName} */}
                      {AdditionalProjectInfo ? `[${AdditionalProjectInfo}] ${ProjectName}` : ProjectName}
                    </span>
                  )
                )}
              </>
                    )}

                    {HighlightTimeEntriesBy !== "Client" && isTimeOff && AccountTimeOffType != null && ShowProjectForTimeOff && (
                      //<span>{" • " + AccountTimeOffType}</span>
                      <span className={"timeofftype projectTaskHeading"} style={{paddingLeft: 0}}>{AccountTimeOffType}</span>
                    )}
                  </>
                )}
              </div>

             
              {!isUnselected && (
                <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '100%', fontSize: '12px', color: '#7e8299' }}>
                  {HighlightTimeEntriesBy === "Client" && showClient ? (
                    <>
                      {!isReadOnly && !isLocked && (TaskName == null || TaskName === '') &&
                        <span style={{ verticalAlign: 'middle' }}>
                          <i className="ki-outline ki-add-item fs-4" style={{ color: '#000', paddingTop: 10 }}></i>
                        </span>
                      }
                      {(ShowProjectForTimeOff && isTimeOff || !isTimeOff) && (
                        <>
                          {ProjectName != null && (
                        // <span className={"project rowItemColor"}>{ProjectName + " • "}</span>
                        <span className={"project rowItemColor"}>{AdditionalProjectInfo ? `[${AdditionalProjectInfo}] ${ProjectName}` : ProjectName + " • "}</span>
                      )}
                          {TaskName != null && (
                        // <span className={"task rowItemColor"}>{TaskName}</span>
                        <span className={"task rowItemColor"}>{AdditionalTaskInfo ? `${TaskName} (${AdditionalTaskInfo})` : TaskName}</span>
                      )}
{ProjectName !== null ? (
                        null
                      ) : (
                          <span style={{ paddingLeft: 4, color: '#172b4d' }}>
                            {isTimeOff && ShowProjectForTimeOff ? (
                              [
                              //  showClient && getValueFromResource('Select Client', dispatch, t),
                              //   showClient
                              //     ? getValueFromResource('Project', dispatch, t)
                              //     : getValueFromResource('Select Project', dispatch, t),
 
                              //   getValueFromResource('Time Off Type', dispatch, t),
                               
                              ]
                                .filter(Boolean)
                                .join(' - ')
                            ) : (
                              [
                                showClient && getValueFromResource('Select Client', dispatch, t),
                                showClient
                                  ? getValueFromResource('Project', dispatch, t)
                                  : getValueFromResource('Select Project', dispatch, t),
 
                                ShowProjectTask && getValueFromResource('Task', dispatch, t),
                                showCostCenter && getValueFromResource('Cost Center', dispatch, t),
                                showWorkType && getValueFromResource('Work Type', dispatch, t),
                              ]
                                .filter(Boolean)
                                .join(' - ')
                            )}
                          </span>
 
 
 
                      )}
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {!isReadOnly && !isLocked && (TaskName == null || TaskName == '') &&
                        <span style={{ verticalAlign: 'middle' }}>
                          <i className="ki-outline ki-add-item fs-4" style={{ color: '#000', paddingTop: 10 }}></i>
                        </span>
                      }
                      {ShowProjectForTimeOff && showClient && ClientName != null && (
                        <span className="client rowItemColor">{ClientName} • </span>
                      )}
                      {!isTimeOff && showClient && ClientName != null && (
                        <span className="client rowItemColor">{ClientName} • </span>
                      )}
                      {(ShowProjectForTimeOff && isTimeOff || !isTimeOff) &&
                    <>
                      {
                       
                        ProjectName != null ?
                          // <span className={"project rowItemColor"}>{ProjectName}</span> :
                          <span className={"project rowItemColor"}>{AdditionalProjectInfo ? `[${AdditionalProjectInfo}] ${ProjectName}` : ProjectName}</span> :
                        //   <span style={{ paddingLeft: 4, color: '#172b4d' }}>
                        //   {getValueFromResource('Select Project', dispatch, t)} - {getValueFromResource('Task', dispatch, t)}
                        // </span>
                         
                          <span style={{ paddingLeft: 4, color: '#172b4d' }}>
                            {isTimeOff && ShowProjectForTimeOff ? (
                              [
                              //  showClient && getValueFromResource('Select Client', dispatch, t),
                              //   showClient
                              //     ? getValueFromResource('Project', dispatch, t)
                              //     : getValueFromResource('Select Project', dispatch, t),
 
                              //   getValueFromResource('Time Off Type', dispatch, t),
                               
                              ]
                                .filter(Boolean)
                                .join(' - ')
                            )
                             : (
                              [
                                showClient && getValueFromResource('Select Client', dispatch, t),
 
                                showClient
                                  ? getValueFromResource('Project', dispatch, t)
                                  : getValueFromResource('Select Project', dispatch, t),
 
                                ShowProjectTask && getValueFromResource('Task', dispatch, t),
                                showCostCenter && getValueFromResource('Cost Center', dispatch, t),
                                showWorkType && getValueFromResource('Work Type', dispatch, t),
                              ]
                                .filter(Boolean)
                                .join(' - ')
                            )}
                          </span>
                      }
                    </>
                  }
                    </>
                  )}
                  {HighlightTimeEntriesBy === "Client" && ShowProjectForTimeOff && (
                    <span className={"costcenter rowItemColor"}>{AccountTimeOffType && !showClient ?  " • " +  AccountTimeOffType : AccountTimeOffType }</span>
                  )}
                  {showCostCenter && !isTimeOff && <span>{CostCenter && " • " + CostCenter}</span>}
                  {showWorkType && !isTimeOff && <span>{WorkType && " • " + WorkType}</span>}
                  {isTimeOff && ShowProjectForTimeOff != true && (
                    <>
                      {AccountTimeOffType != null ? (
                        <span>{AccountTimeOffType}</span>
                      ) : (
                        <span>{getValueFromResource('Select Time Off', dispatch, t)}</span>
                      )}
                    </>
                  )}
                </div>
              )}
            </div>

            {dropdownVisible && isTimeOff === null && (
              <TimesheetCustomDropodown
                {...props}
                setDropdownVisible={setDropdownVisible}
              />
            )}
            {dropdownVisible && AccountEmployeeTimeOffRequestId === null && (
              <TimesheetCustomDropodown
                {...props}
                setDropdownVisible={setDropdownVisible}
              />
            )}
          </div>

          {!isSubmitted && 
 enableTimerInTimesheet && 
 ProjectName != null && 
 !isTimeOff && 
 (moment(new Date()).format('yyyy-MM-DD') >= startDate && moment(new Date()).format('yyyy-MM-DD') <= endDate) && 
 (sessionAccountEmployeeId == accountEmployeeId) && isTimerVisible && (
            <div style={{ flexShrink: 0 }}>
              <div className='symbol symbol-circle symbol-30px'>
                <div
                  className="symbol symbol-25px me-2"
                  data-tooltip-id="tooltip-Description"
                  data-tooltip-content={
                    !isTodayWorkingDay
                      ? "Timer cannot be started because today is a non-working day."
                      : IsTimer
                        ? "Stop Timer"
                        : "Start Timer"
                  }
                  data-tooltip-place="top"
                >
                  {IsTimer ? (
                    <span
                      className={`symbol-label bg-light-danger ${
                        IsTimer && isTimerPulsing ? 'pulse pulse-danger' : ''
                      } ${!isTodayWorkingDay ? 'opacity-50 cursor-not-allowed' : 'cursor'}`}
                      onClick={() => {
                        if (isTodayWorkingDay) stopTimer(rowId);
                      }}
                      style={!isTodayWorkingDay ? { pointerEvents: 'none', opacity: 0.5 } : {}}
                    >
                      <i className="bi bi-stop fs-2 text-danger"></i>
                      {IsTimer && isTimerPulsing && <span className="pulse-ring"></span>}
                    </span>
                  ) : (
                    <span
                      className={`symbol-label bg-light-success ${!isTodayWorkingDay ? 'opacity-50 cursor-not-allowed' : 'cursor'}`}
                      onClick={() => {
                        if (isTodayWorkingDay) startTimer(rowId);
                      }}
                      style={!isTodayWorkingDay ? { pointerEvents: 'none', opacity: 0.5 } : {}}
                    >
                      <i className="bi bi-play fs-2 text-success"></i>
                    </span>
                  )}
                </div>
              </div>
            </div>
          )}

        </div>
      </td>
    </tr>
  )
}

export default TimesheetRow;


// import React, { useRef, useEffect, useState } from 'react'
// import TimesheetCustomDropodown from './TimesheetCustomDropodown'
// import { useAppDispatch, useAppSelector } from '../../app/hooks';
// import { ShowToast } from '../../common/Toastr';
// import { getTimeFromDecimal, timeConverIntoSeconds } from '../../common/timesheetFunction';
// import { updateTimerTimesheetState, addAccountEmployeeTimeEntryTimerAsync, stopAccountEmployeeTimeEntryTimerAsync, getTimer, deleteAccountEmployeeTimeEntryTimerAsync, resetTimerState } from '../../features/timesheet/timesheetSlice';
// import moment from 'moment';
// import { t } from "i18next";
// import { getValueFromResource } from '../../common/timeLiveFunction';

// interface TimesheetRowProps {
//   rowId: number;
//   isReadOnly?: boolean;
// }

// const TimesheetRow = (props: TimesheetRowProps) => {
//   const { rowId, isReadOnly } = props;
//   const state = useAppSelector((state) => state.timesheet);
//   const { showClient, showCostCenter, showWorkType, timeEntriesList, ShowProjectForTimeOff, ShowProjectTask, startDate, endDate, timeEntryViewType,
//     accountEmployeeTimeEntryPeriodId, lastEntryTimerId, accountEmployeeId, enableTimerInTimesheet, timerObject, isLocked, isSubmitted, workingDayNo, isTimerPulsing } = state;
//   const pickerRef = useRef<HTMLDivElement>(null);
//   const textInputRef = useRef<HTMLDivElement>(null);
  
//   const [dropdownVisible, setDropdownVisible] = useState(false);
//   const [isOverflowing, setIsOverflowing] = useState(false);

  
//   const { ClientName, ProjectName, TaskName, CostCenter, WorkType, isTimeOff, AccountTimeOffType, IsTimer, AccountEmployeeTimeOffRequestId } = timeEntriesList.find(x => x.rowId === rowId);
//   const { sessionAccountEmployeeId, HighlightTimeEntriesBy } = useAppSelector((state) => state.globalState);
//   const dispatch = useAppDispatch();
//   const currentDayNo = moment().isoWeekday().toString();
//   const activeDaysArray = workingDayNo ? workingDayNo.split(',') : [];
//   const isTodayWorkingDay = activeDaysArray.includes(currentDayNo);
//   const [isProcessing, setIsProcessing] = useState(false); 
  
//   const startTimer = (rowId: number) => {
//     if (isProcessing) return;
//     if (lastEntryTimerId != 0) {
//       ShowToast('warning', 'Please stop the previous timer!', "warning", "toast-top-right");
//     } else {
//       setIsProcessing(true); // Lock lagayein
//       dispatch(resetTimerState());
//       const { AccountClientId, AccountProjectId, AccountProjectTaskId, timeEntries } = timeEntriesList.find(x => x.rowId === rowId) || {};
//       let accountEmployeeTimeEntryId = 0;
//       timeEntries?.map((item: any) => {
//         if (item.TimeEntryDate == moment(new Date()).format("YYYY-MM-DD")) {
//           accountEmployeeTimeEntryId = item.AccountEmployeeTimeEntryId;
//         }
//       });
//       let object = {
//         "AccountEmployeeTimeEntryPeriodId": accountEmployeeTimeEntryPeriodId,
//         "AccountClientId": AccountClientId,
//         "AccountProjectId": AccountProjectId,
//         "AccountProjectTaskId": AccountProjectTaskId,
//         "TimerDate": moment(new Date()).format('YYYY-MM-DD'),
//         "TimeEntryStartDate": startDate,
//         "TimeEntryEndDate": endDate,
//         "TimeEntryViewType": timeEntryViewType,
//         "AccountEmployeeTimeEntryId": accountEmployeeTimeEntryId,
//         "AccountEmployeeId": accountEmployeeId
//       };
//       dispatch(updateTimerTimesheetState([{ rowId: rowId, isPlay: true }]));
//       dispatch(addAccountEmployeeTimeEntryTimerAsync(object))
//         .unwrap()
//         .then((result) => {
//           if (Number(result.id) > 0) {
//             dispatch(getTimer());
//             ShowToast('Success', 'Timer Started Successfully!', "success", "toast-top-right");
//           } else {
//             ShowToast('error', 'The timer was not started successfully!', "error", "toast-top-right");
//           }
//         })
//         .finally(() => {
//           setIsProcessing(false);
//         });
//     }
//   };

//   const stopTimer = (rowId: number) => {
//     let tempHours = ''
//     state.timeEntriesList.map((item: any) => {
//       if (item.IsTimer) {
//         tempHours = getTimeFromDecimal(item.timeEntries.filter((x: any) => x.TimeEntryDate == moment(new Date()).format("YYYY-MM-DD"))[0].Hours, false);
//       }
//     });
//     dispatch(updateTimerTimesheetState([{ rowId: rowId, isPlay: false }]));
//     if (timerObject[0].minutes >= 1) {
//       dispatch(stopAccountEmployeeTimeEntryTimerAsync(timeConverIntoSeconds(tempHours)))
//         .unwrap()
//         .then((result) => {
//           if (Number(result.id) > 0) {
//             dispatch(resetTimerState());
//             ShowToast('Success', 'TimeEntry Updated Successfully!!', "success", "toast-top-right");
//           }
//           else {
//             ShowToast('error', 'TimeEntry is not Updated Successfully!', "error", "toast-top-right");
//           }
//         })
//     } else {
//       dispatch(deleteAccountEmployeeTimeEntryTimerAsync()).then((result) => {
//         dispatch(resetTimerState());
//         ShowToast('Warning', 'To Save the entry, Total time must be 1 minute or above', "warning", "toast-top-right");
//       });
//     }
//   }

//   const handleClick = (e: any) => {
//     const inputElement = pickerRef.current;
//     if (inputElement && inputElement.contains(e.target)) {
//       return;
//     }
//     setDropdownVisible(false);
//   }

//   const toggleDropdown = () => {
//     setDropdownVisible(!dropdownVisible);
//   }

//   useEffect(() => {
//     document.addEventListener("mousedown", handleClick);
//     return () => {
//       document.removeEventListener("mousedown", handleClick);
//     }
//   }, []);

//   const handleMouseEnter = () => {
//     if (textInputRef.current) {
//       const { scrollWidth, clientWidth } = textInputRef.current;
//       setIsOverflowing(scrollWidth > clientWidth);
//     }
//   };

//   const getFullTooltipText = () => {
//     let text = '';
//     if (HighlightTimeEntriesBy === "Client" && showClient) {
//       text += ClientName || '';
//       if (ProjectName) text += (text ? ' • ' : '') + ProjectName;
//       if (TaskName) text += (text ? ' • ' : '') + TaskName;
//     } else {
//       if (ShowProjectTask && TaskName) text += TaskName;
//       else if (ProjectName) text += ProjectName;
//       if (showClient && ClientName) text += (text ? ' • ' : '') + ClientName;
//       if (ProjectName && ShowProjectTask) text += (text ? ' • ' : '') + ProjectName;
//     }
//     if (showCostCenter && CostCenter && !isTimeOff) text += (text ? ' • ' : '') + CostCenter;
//     if (showWorkType && WorkType && !isTimeOff) text += (text ? ' • ' : '') + WorkType;
//     if (isTimeOff && AccountTimeOffType) text += (text ? ' • ' : '') + AccountTimeOffType;
//     return text;
//   };

//   const isTimerVisible = !isSubmitted &&
//     enableTimerInTimesheet &&
//     ProjectName != null &&
//     !isTimeOff &&
//     (moment(new Date()).format('yyyy-MM-DD') >= startDate && moment(new Date()).format('yyyy-MM-DD') <= endDate) &&
//     (sessionAccountEmployeeId == accountEmployeeId);

//   const isUnselected = ProjectName == null && (!isTimeOff || AccountTimeOffType == null);
//   const tooltipText = getFullTooltipText();

//   return (
//     <tr className={"timesheet-row"} style={{ borderLeftStyle: 'hidden', borderRightStyle: 'hidden' }}>
//       <td style={{ padding: '8px 12px', maxWidth: '380px', width: '380px' }}>
//         <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
          
//           <div 
//             ref={pickerRef} 
//             className={"timesheet-picker"} 
//             style={{ cursor: 'pointer', flex: 1, minWidth: 0, overflow: 'hidden', paddingRight: '8px' }}
//             onMouseEnter={handleMouseEnter}
//             data-tooltip-id="my-tooltip-styles"
//             data-tooltip-content={tooltipText}
//           >
//             <div 
//               ref={textInputRef}
//               className={"tmg--input"} 
//               onClick={isLocked ? undefined : () => toggleDropdown()}
//               style={{
//                 width: '100%',
//                 display: 'flex',
//                 flexDirection: 'column',
//                 gap: '2px'
//               }}
//             >
             
//               <div style={{ fontWeight: 'bold', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '100%' }}>
//                 {isUnselected ? (
//                   <span style={{ color: '#172b4d', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '4px' }}>
//                     {!isReadOnly && !isLocked && (
//                       <span style={{ verticalAlign: 'middle' }}>
//                         <i className="ki-outline ki-add-item fs-4" style={{ color: '#000' }}></i>
//                       </span>
//                     )}
//                     {[
//                       showClient && getValueFromResource('Select Client', dispatch, t),
//                       showClient ? getValueFromResource('Project', dispatch, t) : getValueFromResource('Select Project', dispatch, t),
//                       ShowProjectTask && getValueFromResource('Task', dispatch, t),
//                       showCostCenter && getValueFromResource('Cost Center', dispatch, t),
//                       showWorkType && getValueFromResource('Work Type', dispatch, t),
//                     ].filter(Boolean).join(' - ')}
//                   </span>
//                 ) : (
//                   <>
//                     {HighlightTimeEntriesBy === "Client" && showClient ? (
//                       showClient && ClientName && <span>{ClientName}</span>
//                     ) : (
//                       ShowProjectTask ? (
//                         TaskName && <span>{TaskName}</span>
//                       ) : (
//                         ProjectName && <span>{ProjectName}</span>
//                       )
//                     )}

//                     {HighlightTimeEntriesBy !== "Client" && isTimeOff && AccountTimeOffType != null && ShowProjectForTimeOff && (
//                       <span>{" • " + AccountTimeOffType}</span>
//                     )}
//                   </>
//                 )}
//               </div>

             
//               {!isUnselected && (
//                 <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '100%', fontSize: '12px', color: '#7e8299' }}>
//                   {HighlightTimeEntriesBy === "Client" && showClient ? (
//                     <>
//                       {!isReadOnly && !isLocked && (TaskName == null || TaskName === '') &&
//                         <span style={{ verticalAlign: 'middle' }}>
//                           <i className="ki-outline ki-add-item fs-4" style={{ color: '#000' }}></i>
//                         </span>
//                       }
//                       {(ShowProjectForTimeOff && isTimeOff || !isTimeOff) && (
//                         <>
//                           {ProjectName != null && <span>{ProjectName + " • "}</span>}
//                           {TaskName != null && <span>{TaskName}</span>}
//                         </>
//                       )}
//                     </>
//                   ) : (
//                     <>
//                       {!isReadOnly && !isLocked && (TaskName == null || TaskName == '') &&
//                         <span style={{ verticalAlign: 'middle' }}>
//                           <i className="ki-outline ki-add-item fs-4" style={{ color: '#000' }}></i>
//                         </span>
//                       }
//                       {ShowProjectForTimeOff && showClient && ClientName != null && (
//                         <span>{ClientName} • </span>
//                       )}
//                       {!isTimeOff && showClient && ClientName != null && (
//                         <span>{ClientName} • </span>
//                       )}
//                       {(ShowProjectForTimeOff && isTimeOff || !isTimeOff) && (
//                         <>
//                           {ProjectName != null && <span>{ProjectName}</span>}
//                         </>
//                       )}
//                     </>
//                   )}
//                   {HighlightTimeEntriesBy === "Client" && ShowProjectForTimeOff && (
//                     <span>{AccountTimeOffType && !showClient ? " • " + AccountTimeOffType : AccountTimeOffType}</span>
//                   )}
//                   {showCostCenter && !isTimeOff && <span>{CostCenter && " • " + CostCenter}</span>}
//                   {showWorkType && !isTimeOff && <span>{WorkType && " • " + WorkType}</span>}
//                   {isTimeOff && ShowProjectForTimeOff != true && (
//                     <>
//                       {AccountTimeOffType != null ? (
//                         <span>{AccountTimeOffType}</span>
//                       ) : (
//                         <span>{getValueFromResource('Select Time Off', dispatch, t)}</span>
//                       )}
//                     </>
//                   )}
//                 </div>
//               )}
//             </div>

//             {dropdownVisible && isTimeOff === null && (
//               <TimesheetCustomDropodown
//                 {...props}
//                 setDropdownVisible={setDropdownVisible}
//               />
//             )}
//             {dropdownVisible && AccountEmployeeTimeOffRequestId === null && (
//               <TimesheetCustomDropodown
//                 {...props}
//                 setDropdownVisible={setDropdownVisible}
//               />
//             )}
//           </div>

//           {isTimerVisible && (
//             <div style={{ flexShrink: 0 }}>
//               <div className='symbol symbol-circle symbol-30px'>
//                 <div
//                   className="symbol symbol-25px me-2"
//                   data-tooltip-id="tooltip-Description"
//                   data-tooltip-content={
//                     !isTodayWorkingDay
//                       ? "Timer cannot be started because today is a non-working day."
//                       : IsTimer
//                         ? "Stop Timer"
//                         : "Start Timer"
//                   }
//                   data-tooltip-place="top"
//                 >
//                   {IsTimer ? (
//                     <span
//                       className={`symbol-label bg-light-danger ${
//                         IsTimer && isTimerPulsing ? 'pulse pulse-danger' : ''
//                       } ${!isTodayWorkingDay ? 'opacity-50 cursor-not-allowed' : 'cursor'}`}
//                       onClick={() => {
//                         if (isTodayWorkingDay) stopTimer(rowId);
//                       }}
//                       style={!isTodayWorkingDay ? { pointerEvents: 'none', opacity: 0.5 } : {}}
//                     >
//                       <i className="bi bi-stop fs-2 text-danger"></i>
//                       {IsTimer && isTimerPulsing && <span className="pulse-ring"></span>}
//                     </span>
//                   ) : (
//                     <span
//                       className={`symbol-label bg-light-success ${!isTodayWorkingDay ? 'opacity-50 cursor-not-allowed' : 'cursor'}`}
//                       onClick={() => {
//                         if (isTodayWorkingDay) startTimer(rowId);
//                       }}
//                       style={!isTodayWorkingDay ? { pointerEvents: 'none', opacity: 0.5 } : {}}
//                     >
//                       <i className="bi bi-play fs-2 text-success"></i>
//                     </span>
//                   )}
//                 </div>
//               </div>
//             </div>
//           )}

//         </div>
//       </td>
//     </tr>
//   )
// }

// export default TimesheetRow;